export default __webpack_public_path__ + "static/media/PT.ed6e1b6a.svg";